import axios from 'axios'

export default {
  name: 'Init',

  data () {
    return {
      isLoadingAlerts: true,
      isLoadingFeeds: true,
      isLoadingLastUpdate: true,
      isLoadingProducts: true,
      isLoadingSources: true,
      selectedProject: {}
    }
  },

  methods: {
    getProjectData () {
      this.getLastUpdate(this.selectedProject.id)
      this.getSources(this.selectedProject.id)
      this.getFeeds(this.selectedProject.id)
      this.getAlerts(this.selectedProject.id)
    },

    getLastUpdate (id) {
      this.isLoadingLastUpdate = true
      axios.get(process.env.VUE_APP_API_ENDPOINT + '/last_update/' + id)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.selectedProject.lastUpdate = response.data.date
            this.isLoadingLastUpdate = false
          }
        })
        .catch((error) => {
          if (error.response) {
            this.selectedProject = {}
            this.isLoadingAlerts = false
            this.isLoadingFeeds = false
            this.isLoadingLastUpdate = false
            this.isLoadingProducts = false
            this.isLoadingSources = false
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    },

    getSources (id) {
      this.isLoadingSources = true
      axios.get(process.env.VUE_APP_API_ENDPOINT + '/data/sources/' + id)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.selectedProject.sources = response.data
            this.isLoadingSources = false
            if (this.selectedProject.sources.length > 0) {
              this.getProducts(this.selectedProject.id)
            } else {
              this.selectedProject.products = []
              this.selectedProject.productCount = 0
              this.isLoadingProducts = false
            }
          }
        })
        .catch((error) => {
          if (error.response) {
            this.selectedProject = {}
            this.isLoadingAlerts = false
            this.isLoadingFeeds = false
            this.isLoadingLastUpdate = false
            this.isLoadingProducts = false
            this.isLoadingSources = false
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    },

    getFeeds (id) {
      this.isLoadingFeeds = true
      axios.get(process.env.VUE_APP_API_ENDPOINT + '/data/feeds/' + id)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.selectedProject.feeds = response.data
            this.isLoadingFeeds = false
          }
        })
        .catch((error) => {
          if (error.response) {
            this.selectedProject = {}
            this.isLoadingAlerts = false
            this.isLoadingFeeds = false
            this.isLoadingLastUpdate = false
            this.isLoadingProducts = false
            this.isLoadingSources = false
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    },

    getAlerts (id) {
      this.isLoadingAlerts = true
      axios.get(process.env.VUE_APP_API_ENDPOINT + '/alerts/' + id)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.selectedProject.alerts = response.data
            if (response.data.project === undefined) this.selectedProject.alerts.project = []
            if (response.data.source === undefined) this.selectedProject.alerts.source = []
            if (response.data.feed === undefined) this.selectedProject.alerts.feed = []
            this.isLoadingAlerts = false
          }
        })
        .catch((error) => {
          if (error.response) {
            this.selectedProject = {}
            this.isLoadingAlerts = false
            this.isLoadingFeeds = false
            this.isLoadingLastUpdate = false
            this.isLoadingProducts = false
            this.isLoadingSources = false
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    },

    getProducts (projectId) {
      this.isLoadingProducts = true
      axios.post(process.env.VUE_APP_API_ENDPOINT + '/data/products/' + projectId, {
        filterRules: [],
        orderBy: {},
        start: 0,
        end: 10
      })
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.selectedProject.products = response.data.products
            this.selectedProject.productCount = response.data.length
          }
          this.isLoadingProducts = false
        })
        .catch((error) => {
          if (error.response) {
            this.selectedProject.products = []
            this.selectedProject.productCount = 0
            this.isLoadingProducts = false
          }
        })
    }
  }
}
